import { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { cn } from "@/helpers/classNames"

import { useTruncatedParagraphHook } from "./hook"

interface Props {
  text: string
}

const TruncatedParagraph: FunctionComponent<Props> = ({ text }) => {
  const { formattedText, formattedTextRef, isOpen, setIsOpen, showButton } =
    useTruncatedParagraphHook(text)
  const { t } = useTranslation()

  return (
    <div className={cn("w-full font-body-medium-regular text-neutral-700")}>
      <div
        className={cn([isOpen ? "line-clamp-none" : "line-clamp-3"])}
        ref={formattedTextRef}
      >
        <p>{formattedText}</p>
      </div>

      {showButton && (
        <Button
          variant="ghost"
          className="
            font-label-small text-primary-300
            hover:bg-transparent hover:text-primary-400
          "
          type="button"
          size="xs"
          onClick={() => setIsOpen((value) => !value)}
        >
          {isOpen ? t("global.button.showLess") : t("global.button.showMore")}
        </Button>
      )}
    </div>
  )
}

const TruncatedTableCell = ({ text }: { text: string }) => {
  const { formattedText, formattedTextRef, isOpen, setIsOpen, showButton } =
    useTruncatedParagraphHook(text)
  const { t } = useTranslation()

  return (
    <div className="w-32" ref={formattedTextRef}>
      <p
        className={cn([
          "wrap-break-word whitespace-normal",
          isOpen ? "line-clamp-none" : "line-clamp-3",
        ])}
      >
        {formattedText}
      </p>
      {showButton && (
        <Button
          variant="ghost"
          className="
            font-label-small text-primary-300
            hover:bg-transparent hover:text-primary-400
          "
          type="button"
          size="xs"
          onClick={() => setIsOpen((value) => !value)}
        >
          {isOpen ? t("global.button.showLess") : t("global.button.showMore")}
        </Button>
      )}
    </div>
  )
}

export { TruncatedParagraph, TruncatedTableCell }
